import Box from '@mui/material/Box';
import Fade from '@mui/material/Fade';
import Typography from '@mui/material/Typography';
import { Icon } from 'assets/Icon.js';
import { useAppAuth } from 'shared/hooks/auth/useAppAuth.js';
import { getMultiModalConfig } from 'shared/utils/multiModalConfig.js';

import { CompanyContextSelect } from '../CompanyContextSelect/index.js';
import { useTopBarAvatarEffects } from './TopBarAvatar.effects.js';
import {
  Avatar,
  Email,
  MenuItemLabel,
  MenuLink,
  StyledDivider,
  StyledMenuHeader,
  StyledMenuItem,
  UserMenu,
  UserMenuListIcon,
  Username,
} from './TopBarAvatar.styles.js';

interface TopBarProps {
  username: string;
  email: string;
}

export const TopBarAvatar = ({ username, email }: TopBarProps) => {
  const {
    openMenu,
    closeMenu,
    isMenuOpen,
    menuAnchorElement,
    navigateToProfile,
    navigateToTermsAndConditions,
  } = useTopBarAvatarEffects();
  const { logout } = useAppAuth();
  const isMultiModal = Boolean(getMultiModalConfig());

  return (
    <>
      <Box display="flex">
        <Avatar
          src={username}
          size="medium"
          onClick={openMenu}
          data-testid="user-avatar"
        />
      </Box>
      <UserMenu
        id="menu-appbar"
        anchorEl={menuAnchorElement}
        keepMounted
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 165,
        }}
        slots={{ transition: Fade }}
        transitionDuration={200}
        open={isMenuOpen}
        onClose={closeMenu}
        data-testid="user-menu"
      >
        <StyledMenuHeader>
          <Avatar src={username} size="medium" />
          <Box width={200} pl={1.25}>
            <Username noWrap>{username}</Username>
            <Email noWrap>{email}</Email>
          </Box>
        </StyledMenuHeader>
        <StyledMenuItem
          onClick={navigateToProfile}
          data-testid="profile-settings-button"
        >
          <UserMenuListIcon>
            <Icon icon="navigationProfileSettingsSvg" />
          </UserMenuListIcon>
          <MenuItemLabel>Profile settings</MenuItemLabel>
        </StyledMenuItem>
        <StyledMenuItem onClick={navigateToTermsAndConditions}>
          <UserMenuListIcon>
            <Icon
              sx={{ fill: 'transparent' }}
              icon="navigationTcLegalPrivacySvg"
            />
          </UserMenuListIcon>
          <MenuItemLabel>Terms of service</MenuItemLabel>
        </StyledMenuItem>
        <StyledMenuItem onClick={closeMenu}>
          <MenuLink
            href="https://energy-web-foundation.gitbook.io/safc-registry/user-guide"
            target="_blank"
            rel="noopener noreferrer"
          >
            <UserMenuListIcon>
              <Icon icon="helpOutlineRoundedSvg" />
            </UserMenuListIcon>
            <MenuItemLabel>User guide</MenuItemLabel>
          </MenuLink>
        </StyledMenuItem>

        <Box p={1}>
          <CompanyContextSelect />
        </Box>

        {isMultiModal === false && <StyledDivider />}
        {isMultiModal === false && (
          <StyledMenuItem onClick={logout} data-testid="logout-button">
            <UserMenuListIcon>
              <Icon icon="navigationLogoutSvg" />
            </UserMenuListIcon>
            <MenuItemLabel>Logout</MenuItemLabel>
          </StyledMenuItem>
        )}

        <StyledDivider />

        <Typography textAlign="right" p={1} color="gray" fontSize={12}>
          version:
          {' '}
          {process.env.VERSION}
        </Typography>
      </UserMenu>
    </>
  );
};
